import React from "react";
import ReactDOM from "react-dom";
import "./css/style.scss";
import App from "./components/App";

ReactDOM.render(<App />, document.querySelector("#app"));
